/**
 * Admin card: cutover a Global-e merchant onto a second Shopify store (platform transformation).
 */
import { observer } from "mobx-react-lite";
import React from "react";
import ListLayout from "../../../components/layouts/list-layout/list-layout";
import { Button } from "../../../components/inputs/button/button";
import Card from "../../../components/layouts/card/card";
import FontBody1 from "../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../components/fonts/font-props";
import ShopsSelector from "../../../components/shops-selector/shops-selector";
import { FormFieldLine } from "../../../components/form-field-line/form-field-line";
import PlatformTransformationResult from "./components/platform-transformation-result/platform-transformation-result";
import platformTransformationStore from "./stores/platform-transformation-store";
import { isSet } from "../../../models/model-types-methods";

const PlatformTransformationCard: React.FC = observer(() => {
    const store = platformTransformationStore;
    const oldSelected = isSet(store.oldPortal[0]);
    const newSelected = isSet(store.newPortal[0]);

    return (
        <Card
            isExpanded={true}
            toolbar={{
                title: (
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                        Platform Transformation
                    </FontBody1>
                ),
            }}
        >
            <ListLayout>
                <FormFieldLine label="Old portal">
                    <ShopsSelector
                        value={store.oldPortal}
                        onChange={store.setOldPortal}
                        disabled={store.isProcessing || oldSelected}
                        includeSecondaryPortals
                    />
                </FormFieldLine>

                <FormFieldLine label="New portal">
                    <ShopsSelector
                        value={store.newPortal}
                        onChange={store.setNewPortal}
                        disabled={store.isProcessing || newSelected}
                        includeSecondaryPortals
                    />
                </FormFieldLine>

                <Button
                    onClick={() => void store.submit()}
                    text="Run platform transformation"
                    hasLoader={true}
                    isLoading={store.isProcessing}
                    disabled={store.isProcessing || store.isFetchingMetaFields || !store.isValid}
                />

                <PlatformTransformationResult />
            </ListLayout>
        </Card>
    );
});

export default PlatformTransformationCard;
